import { useCallback, useEffect, useState } from 'react';
import { EXPERIMENTS } from '../../constants';
import { useExperiments } from '../../contexts/experiments-context';
import { useTranslation } from '../../contexts/translation-context';
import { EmailDeliverabilityStatus } from './email-validation-types';
import { isEmailDomainMistyped } from './is-email-domain-mistyped';
export const useEmailMistypeCheck = ({ email, hasError })=>{
    const { t } = useTranslation();
    const { isExperimentEnabled } = useExperiments();
    const checkEmailMistypeEnabled = isExperimentEnabled(EXPERIMENTS.CHECK_EMAIL_MISTYPE);
    const message = t('input.email.mistype-check.warning');
    const [status, setStatus] = useState(EmailDeliverabilityStatus.IDLE);
    const validate = useCallback(()=>{
        const value = (email ?? '').trim();
        if (!checkEmailMistypeEnabled || hasError || !value) {
            setStatus(EmailDeliverabilityStatus.IDLE);
            return;
        }
        setStatus(isEmailDomainMistyped(value) ? EmailDeliverabilityStatus.INVALID : EmailDeliverabilityStatus.VALID);
    }, [
        checkEmailMistypeEnabled,
        email,
        hasError
    ]);
    useEffect(()=>{
        setStatus(EmailDeliverabilityStatus.IDLE);
    }, [
        email,
        hasError
    ]);
    return {
        status,
        message,
        validate
    };
};

//# sourceMappingURL=use-email-mistype-check.js.map